import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { fetchConfig } from "../lib/api";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PRICES = [
  { nom: "Starter", prix: "137,90 CHF" },
  { nom: "Growth", prix: "347,90 CHF" },
  { nom: "Brand", prix: "557,90 CHF" },
];

export default function CercleFondateurs() {
  const { data: config } = useQuery({ queryKey: ["config"], queryFn: fetchConfig });
  const places = config?.cercle_places_attribuees ?? 0;

  return (
    <div>
      <Seo routeKey="/pilote" path="/cercle-fondateurs" title="Cercle Fondateurs — 20 places | VIRALYA" description="20 places, clôture le 30 novembre 2026. −30 % à vie contre un témoignage signé après 60 jours." />
      <Header />
      <main className="page">
        <div className="container page-narrow">
          <Link to="/" className="back-link"><ArrowLeft size={15} /> Accueil</Link>
          <div className="final-banner" style={{ textAlign: "left" }}>
            <span className="eyebrow" style={{ color: "var(--v-accent-bright)" }}>Cercle Fondateurs</span>
            <h1 className="h2" style={{ color: "var(--v-text-on-inverse)" }}>20 places, clôture le 30 novembre 2026</h1>
            <p className="lead" style={{ color: "var(--v-text-on-inverse)", opacity: 0.86, marginTop: "0.75rem" }}>
              −30 % à vie. En échange : un témoignage signé après 60 jours et le droit de citer vos chiffres.
            </p>
            <div style={{ display: "flex", gap: "1.5rem", flexWrap: "wrap", margin: "1.5rem 0" }}>
              {PRICES.map((p) => (
                <div key={p.nom}>
                  <div className="mono" style={{ fontSize: "0.75rem", opacity: 0.8 }}>{p.nom}</div>
                  <div className="tnum" style={{ fontFamily: "var(--font-head)", fontSize: "1.5rem", fontWeight: 700, color: "var(--v-accent-bright)" }}>{p.prix}</div>
                </div>
              ))}
            </div>
            <div className="tnum" style={{ fontFamily: "var(--font-head)", fontSize: "2rem", fontWeight: 700 }} data-testid="cercle-counter">
              {places} / 20 <span style={{ fontSize: "0.9rem", fontFamily: "var(--font-mono)", opacity: 0.8 }}>Places attribuées</span>
            </div>
            <p style={{ fontSize: "0.85rem", opacity: 0.8, marginTop: "0.75rem", maxWidth: "min(70ch,100%)" }}>
              Ce compteur est mis à jour à la main, sous 24 heures ouvrables. Il ne bouge pas tout seul. Il n'y a pas d'horloge qui tourne sur cette page.
            </p>
            <div style={{ marginTop: "1.5rem" }}>
              <Link to="/audit" className="btn btn--light" data-testid="cercle-cta">Demander une place <ArrowRight size={16} /></Link>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
